<template>
  <v-container fill-height fluid grid-list-xl>
   

  
   <v-layout wrap>
      
    <v-flex lg12 md12 sm12 v-if="isLoaded">
    <v-tabs
      v-model="active"
      slider-color="blue"
      fixed-tabs
    >
            <v-tab>App Analytics</v-tab>
            <v-tab>User Analytics</v-tab>
            <v-tab>Course Analytics</v-tab>
      <v-tab-item>
        <v-card flat>
          <v-card-text>
              <LMSDevice />
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat>
          <v-card-text>
              <LMSUser />
          </v-card-text>
        </v-card>
      </v-tab-item>
          
      <v-tab-item>
        <v-card flat>
          <v-card-text>
              <LMSCourse />
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs>

        <!-- <v-tabs  fixed-tabs>
            <v-tab>Devices</v-tab>
            <v-tab>Users</v-tab>
            <v-tab>Courses</v-tab>
        </v-tabs> -->
      </v-flex>
    <!-- <LMSDevice /> -->

   </v-layout>

  </v-container>
</template>

<script>

import LMSDevice from '@/views/LMSDevice'
import LMSCourse from '@/views/LMSCourse'
import LMSUser from '@/views/LMSUser'

export default {


  components: {
    LMSDevice,
    LMSUser,
    LMSCourse
  },

  data() {
    return {
      direction: 'left',
      fab: false,
      fling: false,
      hover: true,
      tabs: null,
      isLoaded: false,
      transition: 'slide-y-reverse-transition',
        active: null,
        text: null
      
    }
  },

  created() {
 
      let loader = this.$loading.show({
              color: "green",
              canCancel: true,
              onCancel: this.onCancel,
              loader: 'dots',
              isFullPage: true
            });
      setTimeout(() => {
        this.isLoaded = true
        loader.hide()
      }, 3000)

  },
  methods: {
 
      next () {
        const active = parseInt(this.active)
        this.active = (active < 2 ? active + 1 : 0)
      }
  }
};
</script>

<style scope>
    #create .v-speed-dial {
    position: fixed;
    z-index: 1000;
    top: 80px;
  }


  #create .v-btn--floating {
    position: relative;
  }
  .currentExam {
    position: fixed;
    z-index: 1000;
    top: 130px;
    left: 0;
  }
</style>